import { Injectable } from "@angular/core";
import { BehaviorSubject, Observable } from "rxjs";
import { UserSessionType } from "../../utils/types/core/models/user-session.type";
import { environment as env } from "../../../environments/environment";
import { CoreMapper } from "../../utils/mappers/core/core.mapper";
import { WtfNavigationService } from "../../components/navigation/navigation.service";

@Injectable()
export class ObservableDataService {
    // Logged User.
    private _loggedUser: BehaviorSubject<UserSessionType> = new BehaviorSubject(
        this.getDefaultSession("")
    );

    get loggedUser() {
        return this._loggedUser.asObservable();
    }

    constructor(private navigationService: WtfNavigationService) {}

    getDefaultSession(url: string) {
        let defaultSession = this.getLoggedUser();

        if (!defaultSession) {
            defaultSession = new UserSessionType();
            defaultSession.avatarUrl = url;
        }

        return defaultSession;
    }

    setloggedUser(value: UserSessionType) {
        this._loggedUser.next(value);
        this.navigationService.setNavigationModel(value.menu);
    }

    getLoggedUser(): UserSessionType {
        if (localStorage.getItem(env.accessTokenLocalStorageKey)) {
            const userSession = <UserSessionType>(
                JSON.parse(localStorage.getItem(env.accessTokenLocalStorageKey))
            );
            this.navigationService.setNavigationModel(userSession.menu);
            return userSession;
        }

        return new UserSessionType();
    }
}
